/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

export const fetchBranding = () => ({
  type: 'FETCH_BRANDING_$'
});
